import { call, fork, put, select, takeEvery } from "redux-saga/effects";
import {
  addTagsStatistic,
  createRoi,
  deleteRoi,
  deployRoi,
  fetchRoiWithCvApps,
  getRulesByDeviceId,
  updateDeployRoi,
  updateRoi
} from "../../api/RoiServiceManager";
import { getCVAppData, unSubscribeCVApp } from "../../global/utility/Utils";
import { CreateRuleinRoi, deleteRule, deleteBulkRule } from "../../model/ruleService";
import { FailureCreateRoi, fetchRulesSuccess, fetchRulesByDeviceIdSuccess, ROI_LIST_WITH_CVAPPS_LOADING_STATUS, setCvAppRoiLoading, setRoiListWithCvApps, setRoiListWithCvAppsLoadingStatus, successAddTagsToRoi, successCreateRoi, successCreateRule, successDeleteRoi, successTagRoiResponse, successUpdateRoi, types, updateRoiList } from "../actions";
import { CVAPP_CAMERAADJUSTMENT } from "../../global/constants/cvappConstants";
const activeSession = (state) => state.sessionReducer.activeSession;

function* createRoiSaga(action) {
  try {
    const session = yield select(activeSession);
    const roiResponse = yield call(createRoi, action.payload, session.activeSession);
    if (roiResponse.status === 500) {
      throw new Error("Internal Server Error");
    }
    yield put(successCreateRoi(roiResponse));
  } catch (error) {
    yield put(FailureCreateRoi(error));
    yield put(successCreateRoi([]));
    yield put(successTagRoiResponse([]));
    console.log("Error while create Roi -> " + error);
  }
}

function* addTags(action) {
  try {
    const session = yield select(activeSession);
    const roiResponse = yield call(addTagsStatistic, action.roiId, action.tags, action.siteId, action.selectedTagIds, session.activeSession);
    yield put(successAddTagsToRoi(roiResponse));
  } catch (error) {
    console.log("Error while create Roi -> " + error);
  }
}

function* mapCvApp(action) {
  try {
    yield put(setCvAppRoiLoading(true));
    const session = yield select(activeSession);
    const roiResponse = yield call(deployRoi, action.payload, session.activeSession);
    yield put(successTagRoiResponse(roiResponse));
    yield put(setCvAppRoiLoading(false));
  } catch (error) {
    yield put(setCvAppRoiLoading(false));
    console.log("Error while cvApp mapping Roi -> " + error);
  }
}

function* updateCvAppSubscription(action) {
  try {
    const session = yield select(activeSession);
    const roiResponse = yield call(updateDeployRoi, action.payload, session.activeSession);
    yield put(successTagRoiResponse(roiResponse));
  } catch (error) {
    yield put(FailureCreateRoi(error));
    console.log("Error while cvApp mapping Roi -> " + error);
  }
}

function* getAllRoiListWithExcpandedCvApps() {
  try {
    yield put(setRoiListWithCvAppsLoadingStatus(ROI_LIST_WITH_CVAPPS_LOADING_STATUS.Loading));
    const session = yield select(activeSession);
    const roiResponse = yield call(fetchRoiWithCvApps, session.activeSession?.accountId);
    yield put(setRoiListWithCvApps(roiResponse));
    yield put(updateRoiList(roiResponse));
    yield put(setRoiListWithCvAppsLoadingStatus(ROI_LIST_WITH_CVAPPS_LOADING_STATUS.Loaded));
  } catch (error) {
    yield put(setRoiListWithCvAppsLoadingStatus(ROI_LIST_WITH_CVAPPS_LOADING_STATUS.LoadingFailed));
    console.log("Error while cvApp mapping Roi -> " + error);
  }
}

function* updateRoiSaga(action) {
  try {
    const session = yield select(activeSession);
    const roiResponse = yield call(updateRoi, action.payload, session.activeSession);
    if (roiResponse.status === 500) {
      throw new Error("Internal Server Error");
    }
    yield put(successUpdateRoi(roiResponse));
  } catch (error) {
    yield put(FailureCreateRoi(error));
    console.log("Error while update Roi -> " + error);
  }
}

function* deleteBulkUnsubscribeRoiSaga(action) {
  try {
    const session = yield select(activeSession);
    const roiResponse = yield call(deleteRoi, action.payload, session.activeSession);
    // Handle undefined response as error (in case service doesn't throw)
    if (roiResponse === undefined) {
      yield put(successDeleteRoi("Error"));
    } else {
      yield put(successDeleteRoi(roiResponse));
    }
  } catch (error) {
    yield put(successDeleteRoi("Error"));
    console.log("Error while delete Roi -> " + error);
  }
}

function* deleteRoiSaga(action) {
  try {
    const session = yield select(activeSession);
    const getdeployment = yield call(getCVAppData, action.payload?.resourceidentifier?.deviceid, session.activeSession);
    if (Array.isArray(getdeployment) && getdeployment.length > 0) {
      for (const item of getdeployment) {
        const lowerStatus = item.status.toLowerCase();
        // if (
        //   item &&
        //  typeof item.status === 'string' &&
        //  (lowerStatus === 'deployed' || lowerStatus === 'suspended' || lowerStatus === 'update_failed') &&
        //   item.id
        // ) {
        if (item.id) {
          yield call(unSubscribeCVApp, item.id, session.activeSession);
        }
      }
    }
    const roiResponse = yield call(deleteRoi, action.payload, session.activeSession);
    if (roiResponse === undefined) {
      yield put(successDeleteRoi("Error"));
    } else {
      yield put(successDeleteRoi(roiResponse));
      yield put(successCreateRoi([]));
      yield put (successTagRoiResponse([]));
    }
  } catch (error) {
    yield put(successDeleteRoi("Error"));
    console.log("Error while delete Roi -> " + error);
  }
}

function* unsubscribeObjectBlurringRoiSagas(action) {
  const cvAppName = action.cvappname;
  try {
    const session = yield select(activeSession);
    const unsubscribe = yield call(unSubscribeCVApp, action.payload?.deploymentIds, session.activeSession);
    if (cvAppName === CVAPP_CAMERAADJUSTMENT) {
      // Fire and forget — undeploy already done, deleteBulkRule handles errors internally
      yield fork(function* () {
        const targetDeviceId = action.payload?.resourceidentifier?.deviceid;
        const rulesPayload = {
          accountname: session.activeSession.accountId,
          filter: { $selection: { deviceid: targetDeviceId } }
        };
        const rules = yield call(getRulesByDeviceId, rulesPayload);
        if (rules && Array.isArray(rules)) {
          const ruleIds = rules.map((m) => m.id);
          if (ruleIds.length > 0) {
            yield call(deleteBulkRule, session.activeSession, ruleIds);
          }
        }
      });
    }
    yield put(successDeleteRoi("Success"));
  } catch (error) {
    yield put(successDeleteRoi("Error"));
    console.log("Error while delete Roi -> " + error);
  }
}

function* fetchRulesSaga(action) {
  try {
    const session = yield select(activeSession);
    const response = yield call(getRulesByDeviceId, action.payload, session.activeSession);
    yield put(fetchRulesByDeviceIdSuccess(response));
  } catch (error) {
    console.log("Error while delete Roi -> " + error);
  }
}

function* fetchRulesWithoutRoiSaga(action) {
  try {
    const session = yield select(activeSession);
    const response = yield call(getRulesByDeviceId, action.payload, session.activeSession);
    yield put(fetchRulesSuccess(response));

  } catch (error) {
    console.log("Error while delete Roi -> " + error);
  }
}

function* createRulesSaga(action, roiId) {
  try {
    const session = yield select(activeSession);
    const ruleData = action?.ruleData;
    const response = yield call(CreateRuleinRoi, ruleData);
    if ((ruleData && !ruleData.hasOwnProperty("action")) || (ruleData && ruleData?.action === "AlertUpdate")) {
      yield put(successCreateRule(response));
    }
    const rulePayload = {
      accountname: session.activeSession.accountId,
      filter: {
        $selection: {
          deviceid: ruleData.roiid
        }
      }
    };
    yield put({
      type: types.FETCH_RULES_BY_DEVICE_ID_REQUEST,
      payload: rulePayload
    });
  } catch (error) {
    console.log("Error while delete Roi -> " + error);
  }
}

function* RoiSaga() {
  yield takeEvery(types.CREATE_ROI_REQUEST, createRoiSaga);
  yield takeEvery(types.ADD_STATISTICS, addTags);
  yield takeEvery(types.EDIT_ROI_REQUEST, updateRoiSaga);
  yield takeEvery(types.DELETE_ROI_REQUEST, deleteRoiSaga);
  yield takeEvery(types.FETCH_RULES_BY_DEVICE_ID_REQUEST, fetchRulesSaga);
  yield takeEvery(types.FETCH_RULES_WITHOUT_ROI_REQUEST, fetchRulesWithoutRoiSaga);
  yield takeEvery(types.CV_APP_ROI, mapCvApp);
  yield takeEvery(types.UPDATE_CV_APP_ROI, updateCvAppSubscription);
  yield takeEvery(types.CREATE_RULE, createRulesSaga);
  yield takeEvery(types.GET_ALL_ROILIST_WITH_CVAPPS, getAllRoiListWithExcpandedCvApps);
  yield takeEvery(types.UNSUBSCRIBE_ROI_OF_OBJECTBLURRING, unsubscribeObjectBlurringRoiSagas);
  yield takeEvery(types.DELETE_BULK_UNSUBSCRIBE_ROI_REQUEST, deleteBulkUnsubscribeRoiSaga);
}

export default RoiSaga;
